import { render } from "./GlHeader.vue?vue&type=template&id=7ba98aea&scoped=true"
import script from "./GlHeader.vue?vue&type=script&lang=js"
export * from "./GlHeader.vue?vue&type=script&lang=js"

import "./GlHeader.vue?vue&type=style&index=0&id=7ba98aea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ba98aea"

export default script